var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.heartNumber),function(i){return _c('font-awesome-icon',{key:'icon_' + i,class:_vm.classes,style:({'--x': _vm.coordinates[i], '--y':  _vm.coordinates[i + _vm.heartNumber], '--s': _vm.scales[i]}),attrs:{"icon":"heart"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }